import { LicenseInfo } from '@mui/x-license-pro';
import { type Root, createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import store from './_flux/Store';
import { pushHistory } from './_tools/History';
import { checkUndefinedOrNull } from './_tools/Tools';
import ErrorHandler from './provider/ErrorHandler';
import ThemeProvider from './provider/ThemeProvider';
import { LEAD } from './vars';

declare global {
    interface Window {
        CRISP_WEBSITE_ID?: string;
        $crisp?: any[];
    }
}

let reactContent: Root = undefined;

// Expired 30.09.2023 LicenseInfo.setLicenseKey('0c61285d100cc1d811d1a85467d6c05cTz01MTY3MyxFPTE2OTYwODM2MzQ0NjksUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');
// Expired 12.10.2024 LicenseInfo.setLicenseKey('831e66c148678df1929638b11b608914Tz03NjU1OSxFPTE3Mjg4MDQ0OTAwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');
LicenseInfo.setLicenseKey('a8a14c47a8cc8209ad764e9968e076edTz0xMDAyNTIsRT0xNzYwODYyNTcwMDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');

pushHistory({ pathname: location.pathname });

export function Entry() {
    return (
        <ErrorHandler key="errorHandler">
            <Provider key="storeProvider" store={store}>
                <BrowserRouter key="browserRouter">
                    <ThemeProvider key="themeProvider">
                        {/* <AuthGuard key="authGuard">*/}
                        <App key="app" />
                        {/* </AuthGuard>*/}
                    </ThemeProvider>
                </BrowserRouter>
            </Provider>
        </ErrorHandler>
    );
}

function init() {
    try {
        const rootContainer = document.getElementById('ahdfleet');
        if (!checkUndefinedOrNull(rootContainer)) {
            if (checkUndefinedOrNull(reactContent)) {
                reactContent = createRoot(rootContainer);
            }

            reactContent?.render(<Entry />);
        }
    } catch (e) {
        console.error('Failed to initialize React-Components:', e);
    }
}

function initCrisp() {
    if (!LEAD) {
        init();
        return;
    }

    window.$crisp = [];
    window.CRISP_WEBSITE_ID = 'a5b7d4c6-2d3a-4672-92f2-c82919c4955d';
    const s = document.createElement('script');
    s.src = 'https://client.crisp.chat/l.js';
    s.async = true;
    document.getElementsByTagName('head')[0].appendChild(s);
    init();
}

initCrisp();
